// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.product-type-bulk-form[data-v-f35653ee] {\n  min-height: calc(100vh - 80px);\n}\n.product-type-bulk-spreadsheet[data-v-f35653ee] {\n  width: 100%;\n}\n.product-type-bulk-dialog[data-v-f35653ee] .el-dialog__body {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
